const emitFallbackWarning = (message = '', fallback = {}) =>
  // eslint-disable-next-line
  console.warn(
    'Custom Palette Generation.\nFallback triggered!\n',
    `Rule: ${fallback.rule}\n`,
    `Message: ${message}\n`,
    'Params: ',
    fallback.params
  );

export default emitFallbackWarning;
